import { useState } from "react";
import { Heart, ChatBubbleEmpty, ShareIos } from "iconoir-react";

interface PostActionsDefaultProps {
  isLiked: boolean;
  reactionsCount: number;
  onLike: () => Promise<void>;
  onComment: () => void;
  onShare: () => void;
}

export function PostActionsDefault({
  isLiked,
  reactionsCount,
  onLike,
  onComment,
  onShare,
}: PostActionsDefaultProps) {
  const [isLiking, setIsLiking] = useState(false);
  const [liked, setLiked] = useState(isLiked);
  const [heartCount, setHeartCount] = useState(reactionsCount || 0);

  const handleLikeClick = async () => {
    if (isLiking) return;
    setIsLiking(true);
    try {
      if (liked) {
        setLiked(false);
        setHeartCount((c) => Math.max(0, c - 1));
        // await onUnlike(post.id); // TODO: Implement unlike functionality
      } else {
        setLiked(true);
        setHeartCount((c) => c + 1);
        // await onLike(post.id); // TODO: Implement like functionality
      }
      await onLike();
    } finally {
      setIsLiking(false);
    }
  };

  return (
    <div className="flex flex-row items-center px-8 py-2.5 w-full">
      <button
        onClick={handleLikeClick}
        disabled={isLiking}
        className={`flex items-center justify-center w-10 h-10`}
      >
        <Heart
          className="w-6 h-6 text-[#1E3A3A]"
          fill={liked ? "#000000" : "none"}
          stroke="#1E3A3A"
          strokeWidth={1.2}
        />
        <span className="ml-1 text-sm text-[#1E3A3A] font-sora">
          {heartCount}
        </span>
      </button>
      <button
        onClick={onComment}
        className="flex flex-row items-center justify-center w-auto h-10 ml-auto whitespace-nowrap"
      >
        <ChatBubbleEmpty className="w-6 h-6 text-[#1E3A3A]" />
        <span className="ml-2 text-sm text-[#1E3A3A] font-sora">
          15 Bình luận
        </span>
      </button>
      <button
        onClick={onShare}
        className="flex items-center justify-center w-10 h-10 ml-auto"
      >
        <ShareIos className="w-6 h-6 text-[#1E3A3A]" />
        <span className="ml-2 text-sm text-[#1E3A3A] font-sora">2</span>
      </button>
    </div>
  );
}
